import { defaultGreeks } from "src/apis/mock/data/get-greeks";
export const APXOR_APP_ID = "d0a9aaf8-a1fe-4356-919f-1280a02260ab";
export const FNO_ROLLOVER_SCRIPT_CODE = "FUTSTK";
export const NSE = "NSE";
export const BSE = "BSE";
export const APP_SOURCE = "21";
export const DATE_FORMAT = "DD MMM'YY";
export const DATE_FORMAT_DASH = "DD-MMM-YYYY";
export const DATE_FORMAT_MOI = "DD MMM YY";
export const DATE_FORMAT_LEGS = "DD MMM YYYY";
export const DATE_TIME_FORMAT = "DD MMM YY hh:mm:ss A";
export const CHART_DATE_FORMAT = "DD MMM YY";
export const TIME_FORMAT = "hh:mm A";
export const TIME_FORMAT_WITH_SECONDS = "hh:mm:ss A";
export const SOLACE_TIME_FORMAT = "hhmmss";
export const DATE_MONTH_FORMAT = "D MMM YYYY h:mm a";
export const DEFAULT_LOGIN_URL = "https://login.5paisa.com/?returnurl=https:%2F%2Ffno.5paisa.com%2F";
export const DEMAT_ACCOUNT_OPENING_URL = "https://www.5paisa.com/demat-account?query=fnodemo ";
export const FNO_URL = "https://fno.5paisa.com/";
export const EQUITY_SEGMENT = "Equity";
export const COMMODITY_SEGMENT = "Commodity";
export const CURRENCY_SEGMENT = "Currency";
export const DEPTH_TOKEN_DATA = "depth_token_response";
export const GREEKS_TOKEN_DATA = "greeks_token_response";
export const CASH_PRODUCT = "CASH";
export const OPTIONS_PRODUCT = "OPTIONS";
export const FUTURES_PRODUCT = "FUTURES";
export const PLAN_ID_KEY = "PlanID";
export const CALL_OPTION_TYPE = "CALL";
export const PUT_OPTION_TYPE = "PUT";
export const FUTURE_ABBREVATED = "FUT";
export const FNO_INDEX_ROLL_OVER_SCRIPT_CODE = "FUTIDX";
export const DECIMAL_LENGTH_LIMIT = 2;
export const CURRENCY_DECIMAL_LENGTH_LIMIT = 4;
export const ORDER_STATUS_FULLY_EXECUTED = "Fully Executed";
export const CASH_EXCHANGE = "C";
export const MARGIN_USERID = "Hek68PU5r76";
export const MARGIN_PASSWORD = "D86utK8Mn7";
export const NIFTY_SCRIPCODE = 999920000;
export const SOLACE_CONNECTION_FAILED = "SOLACE_CONNECTION_FAILED";
export const SOCKET_CONNECTION_FAILED = "SOCKET_CONNECTION_FAILED";
export const SOLACE_CONNECTION_SUCCESS = "SOLACE_CONNECTION_SUCCESS";
export const SOCKET_CONNECTION_SUCCESS = "SOCKET_CONNECTION_SUCCESS";
export const SOLACE_SOCKET_CONNECT = "SOLACE_SOCKET_CONNECT";
export const SOLACE_SOCKET_OPEN = "SOLACE_SOCKET_OPEN";
export const SOLACE_SOCKET_RECONNECT = "SOLACE_SOCKET_RECONNECT";
export const ANALYTICS_API_AUTHORIZATION = "A455B472D8E3CFC39E1FE8A7961CE";
export const ANALYTICS_API_URL = "https://analytics.5paisa.com";
export const ANALYTICS_API_FAILURE = "ANALYTICS_API_FAILURE";
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_LOGIN = "USER_LOGIN";
export const CHANNEL_BROADCAST = "5P_AUTH_CHANNEL";
//theme context provider
// export const APP_THEME_KEY = "theme";
// export const THEME_DARK = "dark";
// export const THEME_LIGHT = "light";
// export const BODY_TAG = "body";
// export const DATA_ATTRIBUTE_THEME = "data-theme";
// theme context provider
export const APP_THEME_KEY = "theme";
export const THEME_DARK = "dark";
export const THEME_LIGHT = "light";
export const SYSTEM_THEME = "system-theme";
export const BODY_TAG = "body";
export const DATA_ATTRIBUTE_THEME = "data-theme";
export const SENSEX = "SENSEX";
export const BANKEX = "BANKEX";
export const MIDCPNIFTY = "MIDCPNIFTY";
export const EXCHANGE_TYPE_B = "B";
export const EXCHANGE_TYPE_N = "N";
export const FILTER_SEARCH_MESSAGE_MAP = {
    fno: `Exch eq 'N' and ExchType eq 'D' or Exch eq 'B' and ExchType eq 'D'`,
    equity: `Exch eq 'N' and Series eq 'EQ' or Exch eq 'N' and Series eq 'BE' or Exch eq 'B' and Series ne 'F' and ExchType eq 'C'`,
    currency: `ExchType eq 'U' and StrikeRate ge 0 and Expiry ge 0 and Exch ne 'M' and Exch ne 'B'`,
    commodity: `Exch eq 'M' and ExchType eq 'D' or Exch eq 'N' and ExchType eq 'X'`,
    all: ``,
};
export const ELASTIC_SEARCH_ORDEBY_VALUE = "SymbolOrder,SearchOrder,Expiry,StrikeRate,CPType,Turnoverdata desc, MarketCapital desc, FullName";
//Made this 0 to remove throttling. Prev value = 800
export const DATA_UI_REFRESHRATE = 800; //1 sec
export const TAB_CHANGE_REFRESH_TIME = 60000;
export const SOLACE_GREEKS_TOPIC_PREFIX = "prod/marketfeed/optiongreeks/v1/g";
export const SOLACE_DEPTH_TOPIC_PREFIX = "prod/marketfeed/optiongreeks/v1/g";
export const SOLACE_20DEPTH_TOPIC_PREFIX = "prod/marketfeed/20depth/v1/";
export const DEFAULT_STOCK_INFO_DATA = {
    symbol: "NIFTY 24 Nov 2022",
    exchange: "N",
    exchangeType: "D",
    scripCode: 53395,
    lastTradePrice: 123,
    previousClose: 879,
    expiry: "2022-11-24T00:00:00Z",
    StrikeRate: "",
};
export const DEFAULT_FUT_SCREENER_DATA = {
    p: "priceGainers",
    date: 0,
};
export const DEFAULT_OPT_SCREENER_DATA = {
    p: "mostActiveByContract",
    date: 0,
};
export const advisoryToken = "eRvJAIrNEe2ZI7Sly4f6OIaT0L/6fIFp5tjmDLYOkn4H4mamicQGCAilOg5mOpclFT/lews0uOIcSSZRQVHR4g==";
export const STRATEGY_DATA = {
    bullish: [
        {
            strategyName: "Long Call",
            imgPath: "/fno/assets/strategis/buy_call",
            toolTipMsg: "Buy 1 lot ATM Call",
            isStrikeChangeAllowed: true,
        },
        {
            strategyName: "Bull Call Spread",
            imgPath: "/fno/assets/strategis/bull_call_spread",
            toolTipMsg: "Buy 1 lot ATM call and Sell 1 lot OTM call",
            isStrikeChangeAllowed: true,
        },
        {
            strategyName: "Bull Put Spread",
            imgPath: "/fno/assets/strategis/bull_put_spread",
            toolTipMsg: "Buy 1 lot OTM Put and Sell 1 lot 1 Deep ITM Put",
            isStrikeChangeAllowed: true,
        },
        {
            strategyName: "Long Call Butterfly",
            imgPath: "/fno/assets/strategis/long_call_butterfly",
            toolTipMsg: "Buy 1 lot ITM Call, Sell 2 lots ATM Calls and Buy 1 lot OTM Call",
            isStrikeChangeAllowed: true,
        },
        {
            strategyName: "Short Put",
            imgPath: "/fno/assets/strategis/sell_put",
            toolTipMsg: "Sell 1 lot OTM Put",
            isStrikeChangeAllowed: true,
        },
    ],
    bearish: [
        {
            strategyName: "Long Put",
            imgPath: "/fno/assets/strategis/buy_put",
            toolTipMsg: "Buy 1 lot ATM Put",
            isStrikeChangeAllowed: true,
        },
        {
            strategyName: "Bear Call Spread",
            imgPath: "/fno/assets/strategis/bear_call_spread",
            toolTipMsg: "Buy 1 lot ATM call and Sell 1 lot deep ITM call",
            isStrikeChangeAllowed: true,
        },
        {
            strategyName: "Bear Put Spread",
            imgPath: "/fno/assets/strategis/bear_put_spread",
            toolTipMsg: "Buy 1 lot ITM Put and Sell 1 lot deep OTM Put",
            isStrikeChangeAllowed: true,
        },
        {
            strategyName: "Long Put Butterfly",
            imgPath: "/fno/assets/strategis/long_put_butterfly",
            toolTipMsg: "Buy 1 lot ITM Put, Sell 2 lots ATM Puts and Buy 1 lot OTM Put",
            isStrikeChangeAllowed: true,
        },
        {
            strategyName: "Short Call",
            imgPath: "/fno/assets/strategis/sell_call",
            toolTipMsg: "Sell 1 lot OTM Call",
            isStrikeChangeAllowed: true,
        },
    ],
    neutral: [
        {
            strategyName: "Calendar Call",
            imgPath: "/fno/assets/strategis/calender_call_put",
            toolTipMsg: "Sell 1 ATM CE (near expiry) and buy 1 CE at same strike (Next expiry)",
            isStrikeChangeAllowed: false,
        },
        {
            strategyName: "Calendar Put",
            imgPath: "/fno/assets/strategis/calender_call_put",
            toolTipMsg: "Sell 1 ATM PE (near expiry) and buy 1 PE at same strike (next expiry)",
            isStrikeChangeAllowed: false,
        },
        {
            strategyName: "Short Straddle",
            imgPath: "/fno/assets/strategis/short_straddle",
            toolTipMsg: "Sell 1 lot ATM Call and Sell 1 lot ATM Put with same expiration",
            isStrikeChangeAllowed: true,
        },
        {
            strategyName: "Short Strangle",
            imgPath: "/fno/assets/strategis/short_strangle",
            toolTipMsg: "Sell 1 lot OTM Call and Sell 1 lot OTM Put with same expiration",
            isStrikeChangeAllowed: true,
        },
        // {
        //   strategyName: "Short Iron Condor",
        //   imgPath: "/fno/assets/strategis/short_iron_condor",
        //   toolTipMsg: "Buy 1 ITM CE / Sell 2 OTM CE ",
        //   isStrikeChangeAllowed: true,
        // },
    ],
    others: [
        {
            strategyName: "Straddle",
            imgPath: "/fno/assets/strategis/long_straddle",
            toolTipMsg: "Buy 1 lot ATM call and Sell 1 lot OTM call",
            isStrikeChangeAllowed: false,
        },
        {
            strategyName: "Strangle",
            imgPath: "/fno/assets/strategis/long_strangle",
            toolTipMsg: "Buy 1 lot ATM call and Sell 1 lot OTM call",
            isStrikeChangeAllowed: true,
        },
        {
            strategyName: "Short Call Butterfly",
            imgPath: "/fno/assets/strategis/short_call_butterfly",
            toolTipMsg: "Sell 1 lot ITM Call, Buy 2 lots ATM Call and Sell 1 lot deep OTM Call",
            isStrikeChangeAllowed: true,
        },
        {
            strategyName: "Short Put Butterfly",
            imgPath: "/fno/assets/strategis/short_put_butterfly",
            toolTipMsg: "Sell 1 lot ITM Put, Buy 2 lots ATM Put, Sell 1 lot deep OTM Put",
            isStrikeChangeAllowed: true,
        },
        {
            strategyName: "Ratio Put spread",
            imgPath: "/fno/assets/strategis/put_ratio_spread",
            toolTipMsg: "Buy 1 ITM PE / Sell 2 OTM PUT",
            isStrikeChangeAllowed: true,
        },
        {
            strategyName: "Ratio Call spread",
            imgPath: "/fno/assets/strategis/call_ratio_spread",
            toolTipMsg: "Buy 1 ITM CE / Sell 2 OTM CE ",
            isStrikeChangeAllowed: true,
        },
        // {
        //   strategyName: "Long Iron Condor",
        //   imgPath: "/fno/assets/strategis/long_iron_condor",
        //   toolTipMsg: "Buy 1 ITM CE / Sell 2 OTM CE ",
        //   isStrikeChangeAllowed: true,
        // },
    ],
    customize: [],
};
export const STRATEGY_DATA_NEW = {
    bullish: [
        {
            strategyName: "Naked Call Long",
            imgPath: "/fno/assets/strategis/buy_call",
            toolTipMsg: "Naked Call Long",
            isStrikeChangeAllowed: true,
        },
        {
            strategyName: "Bull Call Spread",
            imgPath: "/fno/assets/strategis/bull_call_spread",
            toolTipMsg: "Bull Call Spread",
            isStrikeChangeAllowed: true,
        },
        {
            strategyName: "Bull Put Spread",
            imgPath: "/fno/assets/strategis/bull_put_spread",
            toolTipMsg: "Bull Put Spread",
            isStrikeChangeAllowed: true,
        },
        // {
        //   strategyName: "Long Call Butterfly",
        //   imgPath: "/fno/assets/strategis/long_call_butterfly",
        //   toolTipMsg: "Long Call Butterfly",
        //   isStrikeChangeAllowed: true,
        // },
        {
            strategyName: "Naked Put Short",
            imgPath: "/fno/assets/strategis/sell_put",
            toolTipMsg: "Naked Put Short",
            isStrikeChangeAllowed: true,
        },
    ],
    bearish: [
        {
            strategyName: "Naked Put Long",
            imgPath: "/fno/assets/strategis/buy_put",
            toolTipMsg: "Naked Put Long",
            isStrikeChangeAllowed: true,
        },
        {
            strategyName: "Bear Call Spread",
            imgPath: "/fno/assets/strategis/bear_call_spread",
            toolTipMsg: "Bear Call Spread",
            isStrikeChangeAllowed: true,
        },
        {
            strategyName: "Bear Put Spread",
            imgPath: "/fno/assets/strategis/bear_put_spread",
            toolTipMsg: "Bear Put Spread",
            isStrikeChangeAllowed: true,
        },
        // {
        //   strategyName: "Long Put Butterfly",
        //   imgPath: "/fno/assets/strategis/long_put_butterfly",
        //   toolTipMsg: "Long Put Butterfly",
        //   isStrikeChangeAllowed: true,
        // },
        {
            strategyName: "Naked Call Short",
            imgPath: "/fno/assets/strategis/sell_call",
            toolTipMsg: "Naked Call Short",
            isStrikeChangeAllowed: true,
        },
    ],
    neutral: [
        {
            strategyName: "Short Straddle",
            imgPath: "/fno/assets/strategis/short_straddle",
            toolTipMsg: "Short Straddle",
            isStrikeChangeAllowed: true,
        },
        {
            strategyName: "Short Strangle",
            imgPath: "/fno/assets/strategis/short_strangle",
            toolTipMsg: "Short Strangle",
            isStrikeChangeAllowed: true,
        },
        {
            strategyName: "Iron Condor",
            imgPath: "/fno/assets/strategis/short_iron_condor",
            toolTipMsg: "Iron Condor",
            isStrikeChangeAllowed: true,
        },
        // {
        //   strategyName: "Short Iron Condor",
        //   imgPath: "/fno/assets/strategis/short_iron_condor",
        //   toolTipMsg: "Buy 1 ITM CE / Sell 2 OTM CE ",
        //   isStrikeChangeAllowed: true,
        // },
        // {
        //   strategyName: "Short Iron Butterfly",
        //   imgPath: "/fno/assets/strategis/calender_call_put",
        //   toolTipMsg: "Short Iron Butterfly",
        //   isStrikeChangeAllowed: false,
        // },
    ],
    others: [
        {
            strategyName: "Long Straddle",
            imgPath: "/fno/assets/strategis/long_straddle",
            toolTipMsg: "Long Straddle",
            isStrikeChangeAllowed: false,
        },
        {
            strategyName: "Long Strangle",
            imgPath: "/fno/assets/strategis/long_strangle",
            toolTipMsg: "Long Strangle",
            isStrikeChangeAllowed: true,
        },
        // {
        //   strategyName: "Long Iron Condor",
        //   imgPath: "/fno/assets/strategis/long_iron_condor",
        //   toolTipMsg: "Buy 1 ITM CE / Sell 2 OTM CE ",
        //   isStrikeChangeAllowed: true,
        // },
        // {
        //   strategyName: "Put Ratio Spread",
        //   imgPath: "/fno/assets/strategis/put_ratio_spread",
        //   toolTipMsg: "Put Ratio Spread",
        //   isStrikeChangeAllowed: true,
        // },
        // {
        //   strategyName: "Call Ratio Spread",
        //   imgPath: "/fno/assets/strategis/call_ratio_spread",
        //   toolTipMsg: "Call Ratio Spread",
        //   isStrikeChangeAllowed: true,
        // },
        // {
        //   strategyName: "Short Call Butterfly",
        //   imgPath: "/fno/assets/strategis/short_call_butterfly",
        //   toolTipMsg: "Short Call Butterfly",
        //   isStrikeChangeAllowed: true,
        // },
        // {
        //   strategyName: "Short Put Butterfly",
        //   imgPath: "/fno/assets/strategis/short_put_butterfly",
        //   toolTipMsg: "Short Put Butterfly",
        //   isStrikeChangeAllowed: true,
        // },
    ],
    customize: [],
};
export const PREFERENCE_DATA = {
    profile: {
        isStickyOrder: false,
    },
    search: {
        selectedScrip: "all",
        message: "",
    },
    watchlist: {
        lastSavedView: "fno-wl",
        selectedSort: "symbol_asc",
        heatmap: true,
    },
    reports: {
        position: {
            filter: "",
        },
        orders: {
            filter: "all",
        },
    },
    dashboard: {
        miniOC: {
            selectedScrip: "NIFTY",
            categorySelected: "Price",
            selectedExpiry: "",
        },
        overview: {
            "999920000": { showChart: false },
            "999920005": { showChart: false },
            // nifty: {
            //   showChart: true,
            // },
            // bankNifty: {
            //   showChart: true,
            // },
        },
    },
    openInterest: {
        openInterest: {
            selectedScrip: "NIFTY",
            selectedExpiry: "",
        },
        multiStrike: {
            selectedScrip: "NIFTY",
            timeSelected: 3,
            timeSelectedTable: 1,
            viewMode: "graph",
            strikes: [[], []],
            niftyCallFrom: "",
            niftyCallTo: "",
            niftyPutFrom: "",
            niftyPutTo: "",
            bNiftycallFrom: "",
            bNiftycallTo: "",
            bNiftyputFrom: "",
            bNiftyputTo: "",
        },
        combinedOI: {
            selectedScrip: "NIFTY",
            timeSelected: 3,
            viewMode: "graph",
        },
    },
    optionChain: {
        selected: [
            {
                selectedScrip: "NIFTY",
                categorySelected: "Price",
                selectedExpiry: "",
                strike: 20,
                greeksList: defaultGreeks(),
            },
            {
                selectedScrip: "NIFTY",
                categorySelected: "Price",
                selectedExpiry: "",
                strike: 20,
                greeksList: defaultGreeks(),
            },
        ],
        isMultiple: false,
    },
    reportHeightData: {
        LEFT: 1,
        RIGHT: 1,
    },
    fnoStats: {
        futureActivity: {
            expiry: "",
        },
        futureScreener: {
            activity: "priceGainers",
            expiry: "",
        },
        optionsActivity: {
            expiry: "",
        },
        optionScreener: {
            activityIndex: "mostActiveByContract",
            activityStock: "mostActiveByContract",
            expiryIndex: "",
            expiryStock: "",
            categoryType: "index",
        },
        futureIntraday: {
            contract: "NIFTY",
            duration: 5,
            expiry: "",
        },
        indexContributor: {
            scrip: "NIFTY 50",
        },
        indiaVix: {
            index: "Nifty",
        },
    },
    orderSettings: {
        equity: {
            qty: 1,
            productType: "delivery",
            priceType: "market",
            key: "equity",
        },
        fno: {
            qty: 1,
            productType: "delivery",
            priceType: "market",
            key: "fno",
        },
        commodity: {
            qty: 1,
            productType: "delivery",
            priceType: "market",
            key: "commodity",
        },
        depthPin: false,
        bracketType: "percent",
        sltrigger: 10,
        profitTrigger: 10,
    },
    buyform: {
        depthPin: false,
    },
    straddlestrangle: {
        selected: {
            scrip: "NIFTY",
            timeSelected: 1,
            type: "Straddle",
            selectedCallStrike: "",
            selectedPutStrike: "",
            isShowIndex: true,
        },
    },
};
//smart strategies const
export const SMARTALGOLOCALSTORAGEKEY = "SmartAlgoKey";
export const AUTORIZATION_SMART_STRATEGIES = "Bearer gXoEflu7SYjnI4l5kcYGBGcEnFmrOf5PsCe%2fc38cksdVXsRhzYPpE9v5aPEL0j%2fh";
export const ALGO_SESSION_WRAPPER_KEY = "Fz6qBm2LYSzsVFg1VHt1SacGpH5MoJIn";
//SMART START END
export const APPNAME = "5PTRADE";
export const APPVER = "1.0";
export const SESSIONTRANFERKEY = "4dddd59bdab77bace6189d001f96487e";
export const OSNAME = "Web"; //"Android";
export const REQUESTCODE = "5PSTWV";
export const SOCKET_SUBSCRIPTION_METHODS = {
    MARKET_FEED_V3: "MarketFeedV3",
    DEPTH_20_SERVICE: "20depth",
    BASE_GREEKS: "optiongreek",
    DEPTH_SERVICE: "MarketDepthService",
    SCRIPT_INFO_FOR_FUTURE: "GetScripInfoForFuture",
    NEW_BASE_GREEKS: "optiongreek",
    GREEKS_INSTRUMENT: "OG",
};
export const SOCKET_EVENT = {
    CONNECT_SOCKET: "CONNECT_SOCKET",
    DISCONNECT_SOCKET: "DISCONNECT_SOCKET",
    SOCKET_STATUS: "SOCKET_STATUS",
    SOLACE_ERROR: "SOLACE_ERROR",
    SOLACE_CONNECTED: "SOLACE_CONNECTED",
    SOCKET_CONNECTED: "SOCKET_CONNECTED",
    SUBSCRIBE: "SUBSCRIBE",
    UNSUBSCRIBE: "UNSUBSCRIBE",
    UNSUBSCRIBE_BY_SUBSCRIBER: "UNSUBSCRIBE_BY_SUBSCRIBER",
    UNSUBSCRIBE_ALL: "UNSUBSCRIBE_ALL",
    RESUBSCRIBE: "RESUBSCRIBE",
    RECONNECT_TO_SOCKET: "RECONNECT_TO_SOCKET",
    SOCKET_ERROR: "SOCKET_ERROR",
    IS_WINDOW_FOCUSED: "IS_WINDOW_FOCUSED",
    SOCKET_DATA: "SOCKET_DATA",
    MARKETFEED_DATA: SOCKET_SUBSCRIPTION_METHODS.MARKET_FEED_V3,
    DEPTH_DATA: SOCKET_SUBSCRIPTION_METHODS.DEPTH_SERVICE,
    DEPTH_20_DATA: SOCKET_SUBSCRIPTION_METHODS.DEPTH_20_SERVICE,
    OPEN_INTEREST_DATA: SOCKET_SUBSCRIPTION_METHODS.SCRIPT_INFO_FOR_FUTURE,
    GREEKS_DATA: SOCKET_SUBSCRIPTION_METHODS.BASE_GREEKS,
    ORDER_DATA: "ORDER_DATA",
    LOGGLY_DATA: "LOGGLY_DATA",
    ANALYTICS_API_FAILURE: "ANALYTICS_API_FAILURE",
    CALL_POSITION_DATA: "CALL_POSITION_DATA",
};
// export const REPORT_TYPE = {
//   POSITION_REPORT: "POSITION",
//   ORDERBOOK_REPORT: "ORDERBOOK",
//   VTT_REPORT: "VTT",
//   BASKET_REPORT: "BASKET",
//   WATCHLIST_REPORT: "WATCHLIST",
//   SCREENER_REPORT: "SCREENER",
//   NEWS_REPORT: "NEWS",
// };
export const BOTTOM_REPORT_TYPE = {
    LEFT_REPORT: "LEFT",
    RIGHT_REPORT: "RIGHT",
};
export const HEIGHT_DATA = {
    NORMAL: 1,
    EXPANDED: 2,
};
//SMART START END
export const DEFAULT_GREEK_OPTIONS = [
    { id: "DELTA" },
    { id: "THETA" },
    { id: "VEGA" },
    { id: "GAMMA" },
    { id: "IV" },
];
export const greeksSetting = {
    expandedGreeks: "expandedGreeks",
    greeksList: "greeksList",
}; //removed after Preference settings
export const INDEX_SYMBOL = ["NIFTY", "BANKNIFTY", "FINNIFTY"];
export const DEFAULT_OPTION_CHAIN = {
    selectedScript: "NIFTY",
    selectedOptionType: "Price",
    getSelectedExpiry: "",
};
//Order Time Type
export const ORDER_TIME_TYPE = {
    VTT: "vtt",
    REGULAR: "regular",
};
//Search From which form
export const SEARCH_FROM = {
    VTT: "vtt",
    BASKET: "basket",
    GLOBAL: "global",
};
export const GLOBAL_DEFAULT_DATA = {
    orderType: "sell",
};
export const PLEDGE = "pledge";
export const UNPLEDGE = "unpledge";
export const VTT_STATUS = {
    EXECUTED: "Executed",
    REJECTED: "Rejected",
    PENDING: "Pending",
    MODIFIED: "Modified",
    TRIGGERED: "Triggered",
    CANCELLED: "Cancelled",
    SL_TRIGGERED: "SL-Triggered",
    TGT_TRIGGERED: "TGT-Triggered",
};
export const ERROR_MESSAGE_PLEDGE = "Quantity cannot be  Zero  or greater than DP Free Quantity";
export const ERROR_MESSAGE_UNPLEDGE = "Entered quantity should not be greater than pledge quantity";
export const FIRE_BASE_POLLING = {
    QA: "QA",
    YES: "YES",
    NO: "NO",
};
export const ORDER_SETTINGS = [
    { key: "fno", productType: "FUTURES", segmentType: "Equity" },
    { key: "fno", productType: "OPTIONS", segmentType: "Equity" },
    { key: "fno", productType: "FUTURES", segmentType: "Currency" },
    { key: "equity", productType: "CASH", segmentType: "Equity" },
    { key: "commodity", productType: "FUTURES", segmentType: "Commodity" },
];
export const ORDER_DEVELOP = "development";
export const EXECUTED_ORDERBOOK = {
    EXECUTED: "EXECUTED",
};
//WEBHOOK Base URL
export const WEBHOOK_BASE_URL = "https://openapi.5paisa.com/webhooks/placeorder";
export const COMPANY_DETAILS = {
    //TOTAL 17 Values
    Open: {
        value: "",
        displayName: "Open",
    },
    High: {
        value: "",
        displayName: "High",
    },
    Low: {
        value: "",
        displayName: "Low",
    },
    PClose: {
        value: "",
        displayName: "PClose",
    },
    upperCircuit: {
        value: "",
        displayName: "Upper Circuit",
    },
    lowerCircuit: {
        value: "",
        displayName: "Lower Circuit",
    },
    Volume: {
        value: "",
        displayName: "Volume",
    },
    ATP: {
        value: "",
        displayName: "ATP",
    },
    Category: {
        value: null,
        StockFuture: true,
        StockOptions: true,
        CurrencyFuture: true,
        CommodityFuture: true,
        displayName: "Category",
    },
    INTExposure: {
        value: null,
        displayName: "INT Exposure",
        StockOptions: true,
        StockFuture: true,
        CurrencyFuture: true,
        CommodityFuture: true,
    },
    DELExposure: {
        value: null,
        displayName: "DEL Exposure",
        StockOptions: true,
        StockFuture: true,
        CurrencyFuture: true,
        CommodityFuture: true,
    },
    OpenInterest: {
        value: "",
        Equity: true,
        displayName: "OI",
    },
    OIPercChange: {
        value: "",
        Equity: true,
        displayName: "Change in OI",
    },
    LotSize: {
        value: null,
        Equity: true,
        StockFuture: true,
        StockOptions: true,
        CurrencyFuture: true,
        CommodityFuture: true,
        displayName: "Lot Size",
    },
    Rollover: {
        value: null,
        Equity: true,
        StockOptions: true,
        displayName: "Roll Over",
    },
    // Spot: {
    //   value: null,
    //   Equity: true,
    //   displayName: "Spot Price",
    // },
    marketCap: {
        value: "",
        displayName: "M-Capital(Cr)",
        StockOptions: true,
        StockFuture: true,
        CurrencyFuture: true,
        CommodityFuture: true,
    },
    RollCost: {
        value: null,
        Equity: true,
        displayName: "Roll Cost",
    },
};
export const stockInfoJson = {
    Equity: {
        OpenRate: "OpenRate",
        High: "High",
        Low: "Low",
        PClose: "PClose",
        TotalQty: "TotalQty",
        MarketCapital: "MarketCapital",
        DPR: "DPR",
        AvgRate: "AvgRate",
        ExposureCategory: "ExposureCategory",
        BuyMgnIntra: "BuyMgnIntra",
        BuyMgnDel: "BuyMgnDel",
    },
    StockFuture: {
        OpenRate: "OpenRate",
        High: "High",
        Low: "Low",
        PClose: "PClose",
        DPR: "DPR",
        TotalQty: "TotalQty",
        AvgRate: "AvgRate",
        Lotsize: "Lotsize",
        OpenInterest: "OpenInterest",
        OIPercChange: "OIPercChange",
        SpotPrice: "SpotPrice",
    },
    StockOptions: {
        OpenRate: "OpenRate",
        High: "High",
        Low: "Low",
        PClose: "Pclose",
        TotalQty: "TotalQty",
        DPR: "DPR",
        AvgRate: "AvgRate",
        Lotsize: "Lotsize",
        OpenInterest: "OpenInterest",
        OIPercChange: "OIPercChange",
        SpotPrice: "SpotPrice",
    },
    Index: {
        OpenRate: "OpenRate",
        High: "High",
        Low: "Low",
        PClose: "PClose",
        FutPrice: "FutPrice",
        ExposureCategory: "ExposureCategory",
        BuyMgnIntra: "BuyMgnIntra",
        BuyMgnDel: "BuyMgnDel",
    },
    CurrencyFuture: {
        OpenRate: "OpenRate",
        High: "High",
        Low: "Low",
        PClose: "Pclose",
        TotalQty: "TotalQty",
        AvgRate: "AvgRate",
        DPR: "DPR",
        BuyMgnIntra: "BuyMgnIntra",
        BuyMgnDel: "BuyMgnDel",
        Lotsize: "Lotsize",
        OpenInterest: "OpenInterest",
        OIPercChange: "OIPercChange",
        SpotPrice: "SpotPrice",
    },
    CommodityFuture: {
        OpenRate: "OpenRate",
        High: "High",
        Low: "Low",
        PClose: "Pclose",
        TotalQty: "TotalQty",
        AvgRate: "AvgRate",
        DPR: "DPR",
        BuyMgnIntra: "BuyMgnIntra",
        BuyMgnDel: "BuyMgnDel",
        Lotsize: "Lotsize",
        OpenInterest: "OpenInterest",
        OIPercChange: "OIPercChange",
        SpotPrice: "SpotPrice",
        MaxOrderSize: "MaxOrderSize",
        DeliveryUnit: "DeliveryUnit",
        PriceQuotation: "PriceQuotation",
        Maturity: "Maturity",
        TenderPrdStartDt: "TenderPrdStartDt",
        TenderPrdEndDt: "TenderPrdEndDt",
        DeliveryStartDt: "DeliveryStartDt",
        DeliveryEndDt: "DeliveryEndDt",
        ContractStartDt: "ContractStartDt",
        ContractEndDt: "ContractEndDt",
        LTD: "LTD",
        Quater: "Quater",
    },
    Mapping: {
        OpenRate: "Open",
        High: "High",
        Low: "Low",
        PClose: "Pclose",
        TotalQty: "Volume",
        AvgRate: "ATP",
        SpotPrice: "Spot Rate",
        MarketCapital: "Market Cap",
        DPR: "DPR",
        FutPrice: "Future Price",
        ExposureCategory: "Category",
        BuyMgnIntra: "INT Exposure",
        BuyMgnDel: "DEL Exposure",
        OpenInterest: "OI",
        OIPercChange: "Change In OI",
        Lotsize: "Lot Size",
        // MktLot: "Lot Size",
        RollOver: "RollOver",
        RollCost: "Rollover Cost",
        LTD: "Last Trading Day",
        High52Week: "52Week High",
        Low52Week: "52Week Low",
        Quantity: "QTY Unit",
        MaxOrderSize: "Quantity limit",
        DeliveryUnit: "Delivery Unit",
        PriceQuotation: "Price Quote",
        Maturity: "Maturity",
        ContractStartDt: "Contract Start",
        ContractEndDt: "Contract End",
        TenderPrdStartDt: "Tender Start",
        TenderPrdEndDt: "Tender End",
        DeliveryStartDt: "Delivery Start",
        DeliveryEndDt: "Delivery End",
        Quater: "Quater",
    },
};
export const ideasTabMap = {
    basket: "DerivativeBasket",
    derivatives: "DerivativeIntraday",
    currency: "DerivativeCurrency",
    commodity: "DerivativeCommodity",
};
export const SOLACE = {
    PROTOCOLVERSION: 5,
    CLEAN: true,
    RECONNECTPERIOD: 1800000,
    CONNECTTIMEOUT: 15 * 1000,
    // USERNAME: "webapp",
    // "omnitest",
    // "omnitest",
    // productionusername:"webapp",
    //"webapp",
    //"appuser",
    // PASSWORD: "webapp",
    // "0mn!Test",
    // "0mn!Test",
    // productionPassword: "webapp",
    // "%pW3b@ppUs3r",
    //"appuser",
    REJECTUNAUTHORIZED: false,
    LASTWILQOS: 2,
    LASTWILLRETAIN: false,
    KEEPALIVE: 15,
    BROKER_URL: "wss://sandesh.5paisa.com:9907",
    // "ws://sandeshuat.5paisa.in:8000",
    // "wss://sandesh.5paisa.com:8443",
    // "ws://10.132.47.11:8000",
    //"ws://10.132.47.11:8000",
    // "ws://sandesh.5paisa.com:8000",
    //"ws://sandeshuat.5paisa.in:8000",
};
export const FIRE_BASE_CONFIG = {
    apiKey: "AIzaSyB_gteKiDdJKB2dGZLD0X1GXEvZWa9XZXA",
    authDomain: "paisa-mf.firebaseapp.com",
    databaseURL: "https://paisa-mf.firebaseio.com",
    projectId: "paisa-mf",
    storageBucket: "paisa-mf.appspot.com",
    messagingSenderId: "945111842441",
    appId: "1:945111842441:web:62b18ca398857c472b5058",
    measurementId: "G-FW30J08J2Z",
};
export const MAX_SCREEN_WIDTH = 1900;
export const STRADDLE_STRANGLE = {
    STRADDLE: "Straddle",
    STRANGLE: "Strangle",
    NIFTY: "NIFTY",
    BANKNIFTY: "BANKNIFTY",
    FINNIFTY: "FINNIFTY",
    MIDCPNIFTY: "MIDCPNIFTY",
};
export const APP_SOURCETRADESTATION = "20";
export const TV_5P_URL = "https://tv.5paisa.com";
export const EXCHANGE_MAPPING = {
    NSE: "N",
    BSE: "B",
    NFO: "N",
    CURR: "N",
    MCX: "M",
    BFO: "B",
};
// Merchant key for Activate Derivative segment
export const MERCHANT_KEY = "8dj$dSSJU2024FNOajJ";
export const APP_SOURCE_SEGMENT_API = "FNO";
